"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Popup;
var _react = _interopRequireDefault(require("react"));
var _reactBlueprintLibrary = require("react-blueprint-library");
var _htmlReactParser = _interopRequireDefault(require("html-react-parser"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function Popup(_ref) {
  var {
    handleClose,
    show,
    content,
    title
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal, {
    size: "md",
    show: show,
    backdrop: true,
    onHide: () => handleClose()
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal.Header, {
    onClose: () => handleClose(),
    title: title
  }), /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal.Body, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col"
  }, content)))));
}